import React from "react";
import { Box, Flex, Heading, HStack, Icon, Stack, Text } from "@chakra-ui/react";
import { IconType } from "react-icons";
import { alpha, useCalTheme } from "./useCalTheme";

/**
 * The heading inside a calendars section card: an icon tile in the section's tone, a title, and one
 * line saying why the section matters. `right` holds the section's own action (a button, a status).
 * Added by the 2026-09-12 design pass (join / participation / notifications / settings).
 */
export function CalSectionHeading({ icon, title, why, tone, right }: {
  icon: IconType; title: React.ReactNode; why?: React.ReactNode; tone?: "accent" | "success" | "warning" | "danger" | "purple"; right?: React.ReactNode;
}) {
  const t = useCalTheme();
  const c = { accent: t.primary, success: t.success, warning: t.warning, danger: t.danger, purple: t.purple }[tone ?? "accent"];
  return (
    <Stack direction={{ base: "column", sm: "row" }} justify="space-between" align={{ base: "stretch", sm: "center" }} spacing={3} mb={4}>
      <HStack spacing={3} align="start" minW={0}>
        <Flex flexShrink={0} w={9} h={9} borderRadius="lg" align="center" justify="center" bg={alpha(c, 0.14)}>
          <Icon as={icon} color={c} boxSize={4} />
        </Flex>
        <Box minW={0}>
          <Heading as="h2" size="sm" letterSpacing="-0.01em" color={t.text}>{title}</Heading>
          {why && <Text fontSize="sm" color={t.muted} mt={0.5}>{why}</Text>}
        </Box>
      </HStack>
      {right && <Box flexShrink={0}>{right}</Box>}
    </Stack>
  );
}
